import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { FieldArray, useFormikContext } from 'formik';

import type { SurveyDetailUpdate } from 'src/types/survey';

import AddNewFormField from './AddNewFormField';
import FormFieldEdit from './FormFieldEdit';

import { styles } from 'src/components/survey/SurveySettings/index.styles';

const FormFieldSettings: FC = () => {
  const { t } = useTranslation('survey');

  const { values } = useFormikContext<SurveyDetailUpdate>();

  return (
    <Box sx={styles.rootCausesSettings}>
      <Box>
        <Typography variant="h6">
          {t('settings.followUpModule.formFields')}
        </Typography>
      </Box>
      <FieldArray
        name="specificSettings.followUp.customFields"
        render={({ push }) => (
          <>
            <Box sx={styles.followUpEditsContainer}>
              {values.specificSettings.followUp.customFields.map(
                (formField, index) => (
                  <FormFieldEdit
                    key={formField.id}
                    {...formField}
                    index={index}
                  />
                ),
              )}
              <AddNewFormField
                push={push}
                fields={[
                  ...(values.specificSettings.followUp.customFields ?? []),
                ]}
              />
            </Box>
          </>
        )}
      />
    </Box>
  );
};

export default FormFieldSettings;
